import React, { useState, useEffect } from 'react';
import { Table, Spin, Button } from 'antd';
import { getData } from '../../config/api-connect';
import { FilterFilled } from '@ant-design/icons';
import * as Styled from './style.js';
import {getSearchFilter,getDateSorter} from '../../utils/filterHelper.jsx'
import Spinner from '../../components/spinner'

const VisitorList = () => {
  const [loading, setLoading] = useState(false);
  const [visitorData, setVisitorData] = useState([]);
  const [availableFilters,setAvailableFilters] = useState([])
  const [selectedTab,setSelectedTab] = useState('Today')

  useEffect(() => {
    getVisitorPasses();
  }, [selectedTab]);

  const getVisitorPasses = async () => {
    setLoading(true);
    try {
      const response = await getData(
        `/cm/get_all_vistor_passes/?tab=${selectedTab}`
      );
      setVisitorData(response.visitor_data || []);
      setAvailableFilters(response.available_filters || []);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  const renderHeader = (title) => (
    <div style={{ textAlign: 'center', fontWeight: 'bold', textWrap: 'nowrap' }}>{title}</div>
  );

  const getArrayDropdownFilter = (dataIndex, arrayKey, data) => {
    const uniqueValues = [
      ...new Set(
        data
          .flatMap(item => item[dataIndex] || [])
          .map(v => v?.[arrayKey])
          .filter(Boolean)
      )
    ];

    return {
      filters: [
        ...uniqueValues.map(v => ({ text: v, value: v })),
        { text: 'Show Empty Only', value: '__EMPTY__' }
      ],

      onFilter: (value, record) => {
        const arr = record[dataIndex] || [];

        if (value === '__EMPTY__') {
          return arr.length === 0;
        }

        return arr.some(item => item?.[arrayKey] === value);
      },

      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? '#1890ff' : undefined }} />
      )
    };
  };

  const columns = [
    {
      title: renderHeader('Check-in'),
      dataIndex: 'check_in_time',
      align: 'center',
      ...getDateSorter('check_in_time')
    },
    {
      title: renderHeader('Reason of Visit'),
      dataIndex: 'reason',
      align: 'center',
      ...getSearchFilter('reason', 'Reason of Visit')
    },
    {
      title: renderHeader('Visitors'),
      dataIndex: 'customers',
      align: 'center',
      render: (customers = []) =>
        customers.length
          ? customers.map(c => c.name).join(', ')
          : '-',
      ...getArrayDropdownFilter('customers', 'name', visitorData)
    },
  ];

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>
        <Styled.Header>Visitor List</Styled.Header>
        <div style={{display: "flex",padding: "12px 0"}}>
          {availableFilters?.length > 0 && (
            <div style={{ display: "flex", gap: "8px", marginBottom: 12 }}>
              {availableFilters.map((filter) => {
                const isActive = selectedTab === filter;
                return (
                  <Button
                    key={filter}
                    type={isActive ? "primary" : "default"}
                    onClick={() => setSelectedTab(filter)}
                    style={
                      isActive
                        ? {
                            backgroundColor: "rgb(2, 71, 92)",
                            borderColor: "rgb(2, 71, 92)",
                          }
                        : {}
                    }
                  >
                    {filter}
                  </Button>
                );
              })}
            </div>
          )}
        </div>
        <div className="recordCount">{visitorData.length || 0} records</div>
        <Table
          className="drill-down-table table_container"
          rowKey="id"
          columns={columns}
          dataSource={visitorData}
          pagination={{ pageSize: 50, showSizeChanger: false }}
          scroll={{ x: 'max-content' }}
        />
      </Styled.MainContainer>
    </Spin>
  );
};

export default VisitorList;